import { render, staticRenderFns } from "./traininglink.vue?vue&type=template&id=085d3c48&"
import script from "./traininglink.vue?vue&type=script&lang=js&"
export * from "./traininglink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports